<template>
  <div id="viewer">
    <el-row :gutter="30" type="flex" align="center" justify='center'>
      <viewer :images="srcArr" class="viewerImg" style="height: 100%">
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          align="center"
          v-for="(item, index) in srcArr"
          :key="index"
        >
          <!-- <div class="innerBox" :style="{'text-align':index%2 == 0?'right':'left'}"> -->
          <div class="innerBox">
            <img :src="item.src" title="查看大图" />
            <div class="tagName" v-if="item.name !== ''&& item.name !== undefined">{{ item.name }}</div>
            <!-- <img class="bigEye" src="../../../assets/img/product/eye.svg" alt="" /> -->
          </div>
          <div class="imgName" v-if="item.imgName !== ''&& item.imgName !== undefined">{{item.imgName}}</div>
        </el-col>
      </viewer>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    srcArr: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
#viewer {
  .innerBox {
    position: relative;
    margin-top: 3rem;
    width: 100%;
    height: 33rem;
    overflow: hidden;
    img {
      width: 100%;
    //   height: 100%;
      border-radius: 4px;
      cursor: pointer;
    }
    .el-image {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      cursor: pointer;
    }
    .tagName {
      position: absolute;
      top: 1rem;
      left: 1rem;
      background: rgba(0, 0, 0, 0.8);
      color: #ffffff;
      border-radius: 2rem;
      padding: 1rem 2rem;
    }
    .bigEye {
      position: absolute;
      bottom: 0rem;
      right: 0rem;
      cursor: pointer;
      background: #18b09b;
      width: 3rem;
      height: 3rem;
      border-radius: 0 0 4px 0;
    }
  }
  .imgName {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 2rem;
    margin-top: 1rem;
  }
  @media screen and (max-width: 1024px) {
    .innerBox {
      height: 18rem;
      .tagName {
        top: 1rem;
        left: 1rem;
        padding: 0.5rem 1rem;
      }
    }
  }
  @media screen and (max-width: 360px) {
    .innerBox {
      height: 12rem;
    }
  }
}
</style>

